import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    modify: {
        id: "general.modify",
    },
    copied: {
        id: "input.copiedToTheClipboard",
    },
});

export default messages;
